import React from 'react';

import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { ProductLineNameStyled, ProductLineTitleStyled } from './styles';
import { PRODUCT_LINE_TITLE_TEST_ID } from '../constants';

interface Props {
  productLineId: ProductLineId;
  className?: string;
}

const ProductLineTitle: React.FC<Props> = ({ productLineId, className }) => {
  return (
    <ProductLineTitleStyled className={className} data-test-id={PRODUCT_LINE_TITLE_TEST_ID}>
      {PRODUCT_LINES_CONTENT_MAP[productLineId]?.icon('2.4rem')}
      <ProductLineNameStyled>{PRODUCT_LINES_CONTENT_MAP[productLineId]?.label}</ProductLineNameStyled>
    </ProductLineTitleStyled>
  );
};

export default ProductLineTitle;
